module.exports = __webpack_public_path__ + "img/g1-en.8399a7aa.jpeg";